import React, { useMemo } from 'react';
import { AdminTableColumn } from '../../components/table/interfaces/AdminTableColumn';
import { WhatsAppUserPreference } from '../dto/WhatsAppUserPreference';
import { useTranslation } from 'react-i18next';
import { AdminDate } from '../../components/table/AdminDate';
import { createStringFilterFunction } from '../../components/table/functions/createStringFilterFunction';
import { AdminTableInputFilter } from '../../components/table/filters/AdminTableInputFilter';

export function useWhatsAppPreferencesColumns(): AdminTableColumn<WhatsAppUserPreference>[] {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        title: t('Phone Number'),
        predicate: (item) => item.phoneNumber.replace('whatsapp:', ''),
        sortingPredicate: (item) => item.phoneNumber,
        filterConfig: {
          filterFn: createStringFilterFunction((item) => item.phoneNumber),
          component: AdminTableInputFilter,
        },
      },
      {
        title: t('Default Customer'),
        predicate: (item) => item.defaultCustomerName || '-',
        sortingPredicate: (item) => item.defaultCustomerName || '',
        filterConfig: {
          filterFn: createStringFilterFunction((item) => item.defaultCustomerName || ''),
          component: AdminTableInputFilter,
        },
      },
      {
        title: t('Frequent Customers'),
        predicate: (item) => {
          if (!item.frequentCustomers || item.frequentCustomers.length === 0) return '-';
          return item.frequentCustomers
            .slice(0, 3)
            .map((c) => `${c.name} (${c.useCount})`)
            .join(', ');
        },
      },
      {
        title: t('Last Updated'),
        predicate: (item) => item.updatedAt ? <AdminDate date={item.updatedAt} /> : '-',
        sortingPredicate: (item) => item.updatedAt || '',
        style: {
          width: 160,
        },
      },
    ],
    [t],
  );
}
